export const MONDAY_ACCOUNT_URL = 'https://monasecurity.monday.com';

/** Canonical item URL on our account sub-domain. Never use the bare monday.com domain (it 404s). */
export function mondayItemUrl(
  boardId: string | number,
  itemId: string | number,
  accountUrl: string = MONDAY_ACCOUNT_URL,
): string {
  return `${accountUrl.replace(/\/+$/, '')}/boards/${boardId}/pulses/${itemId}`;
}

export function isValidMondayUrl(url: string, accountUrl: string = MONDAY_ACCOUNT_URL): boolean {
  return url.startsWith(`${accountUrl.replace(/\/+$/, '')}/boards/`);
}
